<span
  *ngIf="icon"
  class="icon"
  [ngStyle]="{ 'background-image': 'url(' + icon.url + ')' }"
  [attr.data-size]="icon.size | kebabCase"
>
</span>
